import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientCreateInputView のスタイル
 */
export const hotlineClientCreateInputViewStyle = tv({
    slots: {
        commentText: [textStyle({ color: 'base', size: 'sm' }), 'block', 'mt-8'],
        dropdownField: ['max-w-[170px]'],
        fieldsWrap: ['flex flex-col gap-32', 'pt-28 pb-32 px-16 lg:p-32'],
        labelText: ['mb-8'],
        normalText: [textStyle({ color: 'base', size: 'md' }), 'block'],
        shortField: ['min-w-[200px]'],
        warningText: [
            textStyle({ color: 'base', size: 'sm' }),
            'bg-orange-50',
            'p-16',
            'rounded-md',
        ],
    },
});
